<footer
  class="w-dvw h-17.5 bg-white flex items-center justify-center gap-12 border-t border-gray-300">
  <ng-content></ng-content>
</footer>
